import * as Net from 'util/Net';

import {WellAttributionResponse} from './ContainerWellAttributionConstants';

export function fetchWellAttribution(
  inventoryPlateId: string,
  rowIndex: number,
  columnIndex: number
): Promise<WellAttributionResponse> {
  return Net.getJSONPromise('/1/api/scratch-plates:well-attribution', {
    plateId: inventoryPlateId,
    rowIndex,
    columnIndex,
  });
}
